import React from 'react';
import { Link } from 'react-router-dom';

export default class Visits extends React.Component {
  render() {
    return <div className="content">
      <h3 className="title is-3">Visits</h3>
      <h3 className="subtitle">Retrieve a Visit</h3>
      <p>This section covers how to retrieve an individual visit for a patient</p>
      <p>Visits must be fetched by patient id and the visit order</p>

      <h3 className="subtitle">HTTP Request</h3>
      <p><code>GET https://api.ccihub.com/api/patients/{`{patient_id}`}/visits/{`{order}`}</code></p>
      
      <h3 className="subtitle">Request Parameters</h3>
      <table className="table">
        <thead>
          <th>Parameter</th>
          <th>Required</th>
          <th>Type</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>patient_id</td>
            <td>yes</td>
            <td>string</td>
            <td>The id of the patient</td>
          </tr>
          <tr>
            <td>order</td>
            <td>yes</td>
            <td>number</td>
            <td>The order of the visit</td>
          </tr>
        </tbody>
      </table>

      <h3 className="subtitle">Response Parameters</h3>
      <table className="table">
        <thead>
          <th>Property</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>_id</td>
            <td>A unique internal identifier for the visit</td>
          </tr>
          <tr>
            <td>assessments</td>
            <td>Array of assessments to be completed for the visit</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>DateTime the visit resource was created</td>
          </tr>
          <tr>
            <td>do_not_integrate</td>
            <td>A boolean used for internal decisions</td>
          </tr>
          <tr>
            <td>finish</td>
            <td>DateTime the visit was completed</td>
          </tr>
          <tr>
            <td>legacy_id</td>
            <td>Integer used for internal reference</td>
          </tr>
          <tr>
            <td>legacy_sync</td>
            <td>Boolean used for internal reference</td>
          </tr>
          <tr>
            <td>medications</td>
            <td>Array of reported medication criteria</td>
          </tr>
          <tr>
            <td>order</td>
            <td>Integer of the order the visit is delivered</td>
          </tr>
          <tr>
            <td>paused</td>
            <td>Object of paused visit state criteria</td>
          </tr>
          <tr>
            <td>reminder</td>
            <td>String of reminder type (daily, weekly, monthly)</td>
          </tr>
          <tr>
            <td>start</td>
            <td>DateTime the visit was started</td>
          </tr>
          <tr>
            <td>status</td>
            <td>Deprecated - no longer used</td>
          </tr>
          <tr>
            <td>treatments</td>
            <td>Array of reported treatment criteria</td>
          </tr>
          <tr>
            <td>triggered</td>
            <td>Integer used for dynamic visit configurations</td>
          </tr>
          <tr>
            <td>type</td>
            <td>String visit type description</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>DateTime the resource was last updated</td>
          </tr>
        </tbody>
      </table>

      <h3 className="subtitle">Update a Visit</h3>
      <h3 className="subtitle">HTTP Request</h3>
      <p><code>PUT https://api.ccihub.com/api/patients/{`{patient_id}`}/visits/{`{order}`}</code></p>

      <h3 className="subtitle">Request Parameters</h3>
      <table className="table">
        <thead>
          <th>Parameter</th>
          <th>Required</th>
          <th>Type</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>patient_id</td>
            <td>yes</td>
            <td>string</td>
            <td>The id of the patient</td>
          </tr>
          <tr>
            <td>order</td>
            <td>yes</td>
            <td>number</td>
            <td>The order of the visit</td>
          </tr>
        </tbody>
      </table>
          
      <h3 className="subtitle">Visit Request Payload</h3>
      <p>A visit patch request can include any of the properties shown below:</p>
      <p>Pausing a visit requires a specific data structure to be provided.  This can be requested by contacting <a href="mailto: support@ccihub.com">support@ccihub.com</a></p>
      <p>Unsupported properties in the payload will be discarded</p>
      <div className="code-snippet">
<pre><code>
{`{
  visit: {
    finish: 'yyyy-mm-ddThh:mm:ss.ffffff',
    start: 'yyyy-mm-ddThh:mm:ss.ffffff',
    medications [...],
    treatments: [...],
    paused: {...},
    reminder: 'daily'
  }
}`}
</code></pre>
      </div>

      <h3 className="subtitle">Response</h3>
      <p>Returns the updated visit resource</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/api/Visits.js